import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button, Collapse, Typography } from '@mui/material';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const TaskPayload = ({ payload }) => {
  const [expanded, setExpanded] = useState(false);
  const { t } = useTranslation();

  if (!payload) return null;

  return (
    <Box sx={{ mt: 1 }}>
      <Button
        size="small"
        onClick={() => setExpanded(!expanded)}
        endIcon={expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
      >
        {t('ActivityCenter_TechnicalDetails')}
      </Button>
      <Collapse in={expanded}>
        <Box sx={{
          mt: 1,
          p: 1,
          bgcolor: 'background.default',
          border: 1,
          borderColor: 'divider',
          borderRadius: 1,
          maxHeight: 200,
          overflow: 'auto',
        }}
        >
          <Typography
            variant="caption"
            component="pre"
            color="text.primary"
            sx={{
              fontSize: '0.7rem',
              whiteSpace: 'pre-wrap',
              fontFamily: 'monospace',
            }}
          >
            {JSON.stringify(payload, null, 2)}
          </Typography>
        </Box>
      </Collapse>
    </Box>
  );
};

export default TaskPayload;
